// Per-page meta tags + JSON-LD schema injection via React Helmet.
import { Helmet } from "react-helmet-async";

const DEFAULT_OG = "https://customer-assets.emergentagent.com/job_dr-tannu-vedic/artifacts/ad62uzli_IMG_3335.png";
const BASE = "https://vedicbytannu.com";

export default function SEO({ title, description, path = "", image = DEFAULT_OG, type = "website", noindex = false, schema = null }) {
    const fullTitle = title ? `${title} · VedicByTannu` : "VedicByTannu — Premium Vedic Astrology by Dr. Tannu Aggarwal";
    const url = `${BASE}${path}`;
    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            {noindex && <meta name="robots" content="noindex,nofollow" />}
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content={type} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
        </Helmet>
    );
}
